module.exports = __webpack_public_path__ + "static/media/No_policies.cba8a5e5.svg";